// contexts/subscriptionContext.js
import React, { createContext, useContext, useState } from 'react';

// 1) Create context with no default value
const SubscriptionContext = createContext();

/**
 * 2) Provider that lives at the top of your app tree (in index.js).
 *    It holds:
 *      - isSubscribed: boolean|null  (null while checking)
 *      - offerings:   object|null   (your RevenueCat offerings)
 */
export function SubscriptionProvider({ children }) {
  // null = “checking”, true/false = known
  const [isSubscribed, setIsSubscribed] = useState(null);
  const [isRcReady, setIsRcReady] = useState(false);
  const [offerings,   setOfferings]   = useState(null);

  return (
    <SubscriptionContext.Provider value={{
      isSubscribed,
      setIsSubscribed,
      isRcReady,
      setIsRcReady,
      offerings,
      setOfferings
    }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

/**
 * 3) Custom hook to consume the context.
 *    Throws if you forget to wrap in <SubscriptionProvider>.
 */
export function useSubscription() {
  const ctx = useContext(SubscriptionContext);
  if (!ctx) {
    throw new Error(
      'useSubscription() must be used within a <SubscriptionProvider>. ' +
      'Did you forget to wrap your App in SubscriptionProvider?'
    );
  }
  return ctx;
}
